export default function ({ route, redirect }) {
  return redirect({
    name: 'events-event_id-campaigns-campaign_id-landing_page_url',
    params: {
      event_id: route.params.event_id,
      campaign_id: route.params.campaign_id,
    },
  })
}
